import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/components/EventsAwardsAccordionHeader";

/**
 * Component to render participations section for FAQ Page
 */
const ParticipationsSection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150 font-public-sans"
      data-testid="participations-section-component"
    >
      <AccordionV2
        testId="participations"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader
            title="2. Who can participate in the Award?"
            className="px-4"
          />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mx-4 px-6 py-4 pb-0">
          <p>
            The Emerging Enterprise Award and Emerging Enterprise Sustainability
            Award are open to all businesses who satisfy the Eligibility
            Criteria
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default ParticipationsSection;
